



import { defineComponent } from '@nuxtjs/composition-api';
import { SfBullets } from '@storefront-ui/vue';

export default defineComponent({
  name: 'Stepper',
  components: { SfBullets }
});
